import { render, staticRenderFns } from "./departmental_performance_table.vue?vue&type=template&id=54c1d4b2&"
import script from "./departmental_performance_table.vue?vue&type=script&lang=js&"
export * from "./departmental_performance_table.vue?vue&type=script&lang=js&"
import style0 from "./departmental_performance_table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports